import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { RequestQuoteForm } from '../Models/RequestQuoteForm';

class RequestQuoteApi {
  static getRequestQuote(id: string) {
    return axios.get<RequestQuoteForm>(
      `${API_URL}/api/customer/GetRequestQuote/${id}`,
      getAuthHeader()
    );
  }
  static addRequestQuote(request: RequestQuoteForm) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/customer/AddUpdateRequestQuote`,
      request
    );
  }
  static getQuotesList() {
    return axios.get<RequestQuoteForm[]>(
      `${API_URL}/api/customer/GetRequestQuotes`,
      getAuthHeader()
    );
  }
}

export default RequestQuoteApi;
